import React from 'react';
import { st, classes } from './Title.st.css.js';
const Title = ({ children, isSticky = false, }) => (React.createElement("div", { "data-hook": "modalMobileLayout-title", "data-sticky-title": isSticky, className: st(classes.root, {
        isSticky,
    }) }, children));
export default Title;
//# sourceMappingURL=Title.js.map